import { useEffect, useMemo, useRef, useState } from "react";
import { Text as ChakraText } from "~/foundation/Chakra";
import { cubicBezier, motion, useAnimationControls } from "framer-motion";

const Text = motion(ChakraText);

export const CounterNumber = ({
	value,
	number,
	animate,
	duration = 1,
}: {
	place: number;
	value?: number;
	number: number;
	animate: boolean;
	duration?: number;
}) => {
	const [fontSize, setFontSize] = useState<number | null>(null);
	const ref = useRef(null);
	const controls = useAnimationControls();
	const [isFirstRender, setIsFirstRender] = useState(true);

	const initialPosition = useMemo(() => {
		if (!fontSize) return 0;
		return (number + 1) * fontSize;
	}, [number, fontSize]);


	useEffect(() => {
		if (ref.current) {
			setFontSize(parseFloat(window.getComputedStyle(ref.current).fontSize.split("px")[0]) * 0.8);
		}
	}, []);

	useEffect(() => {
		if (!fontSize) return;
		if (isFirstRender) {
			controls.set({ y: initialPosition });
			setIsFirstRender(false);
		}
	}, [controls, setIsFirstRender, initialPosition, isFirstRender, fontSize]);

	useEffect(() => {
		if (!isFirstRender && typeof value !== "undefined" && fontSize) {
			const offset = number - value;
			const memo = offset * fontSize;
			controls.start({
				y: animate ? memo : initialPosition,
				transition: { duration, ease: cubicBezier(.35, 1, .45, 1) },
			});
		}
	}, [animate, isFirstRender, value, controls, initialPosition, number]);

	return (
		<Text
			ref={ref}
			as="span"
			animate={controls}
			fontFamily="heading"
			display="flex"
			fontSize="1em"
			width="1em"
			height="0.5em"
			position="absolute"
			justifyContent="center"
			alignItems="center"
			opacity={isFirstRender ? 0 : 1}
		>
			{number}
		</Text>
	);
};